<template>
  <div class="download-link">
    <NuxtLink :to="`${corePath}${link.nodeId}/`" class="download-link__inner">
      <div class="download-link__image-holder">
        <div class="download-link__image-box">
          <img
            :src="imagePath"
            @error="handleImageError"
            :alt="setProperFieldExternalFirst(image, 'title') || 'image'"
            class="download-link__image"
          />
        </div>
      </div>
      <div class="download-link__content">
        <b class="download-link__title">{{ setProperFieldExternalFirst(link, 'title') }}</b>
      </div>
    </NuxtLink>
  </div>
</template>

<script setup lang="ts">
  import { useMainStore } from '@/stores/main';
  import { FALLBACK_IMAGE_PATH, handleImageError } from '~/utils/imageFallback';

  const props = defineProps({
    link: {
      type: Object,
      default: () => ({})
    }
  });

  const imgRatio = '?width=212&height=212';
  const imgPreview = '/Preview?mimetype=image/jpg';
  const route = useRoute();
  const mainStore = useMainStore();

  const mainCategory = computed(() => route.path.split('/')[1]);

  const image = computed(() => {
    if (props.link.resources && props.link.resources[0]) {
      return props.link.resources[0];
    } else {
      return { fileId: 'noFileId', fileName: 'noFileName', mimeType: '' };
    }
  });

  const imagePath = computed(() => {
    if (image.value.fileId === 'noFileId' || image.value.fileName === 'noFileName') {
      return FALLBACK_IMAGE_PATH;
    }
    if (image.value.mimeType && image.value.mimeType.indexOf('application') > -1) {
      return mainStore.baseUrlMedia + image.value.fileId + '/' + image.value.fileName + imgPreview;
    } else {
      return mainStore.baseUrlMedia + image.value.fileId + '/' + image.value.fileName + imgRatio;
    }
  });

  const corePath = computed(() => {
    return `/${mainCategory.value}/${route.params.category}/${route.params.subcategory}/`;
  });

  // Add the missing utility function
  const setProperFieldExternalFirst = (obj: any, field: string) => {
    if (obj && obj.external && obj.external[field]) {
      return obj.external[field];
    } else if (obj && obj[field]) {
      return obj[field];
    }
    return null;
  };
</script>
